import { css } from '@emotion/css';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { useTheme } from '../../themes';

export const TooltipWhite = (props: TooltipProps) => {
  const theme = useTheme();
  return (
    <Tooltip
      {...props}
      classes={{
        ...props.classes,
        tooltip: css({
          '&&': {
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            border: theme.custom.border.standard
          }
        }),
        arrow: css({
          '&&': {
            color: theme.palette.common.white,
            '&::before': {
              border: theme.custom.border.standard
            }
          }
        })
      }}
    />
  );
};
